import { loadQuery } from 'react-relay';
import { matchRoute } from 'react-resource-router';

import { RelayEnvironment } from '@townsquare/relay-utils/townsquare-environment';
import { createSearchParamsFromCurrentUrl } from '@townsquare/url-utils/search-params';

import { routes } from '../router/routes';

import BootstrapQuery, {
  BootstrapQuery$variables,
  type BootstrapQuery as BootstrapQueryType,
} from './__generated__/BootstrapQuery.graphql';

export const preloadQueryRef = () => {
  const urlSearch = Object.fromEntries(createSearchParamsFromCurrentUrl());
  const matchedRoute = matchRoute(routes, window.location.pathname, urlSearch);
  const context: NonNullable<BootstrapQuery$variables['context']> = { orgId: '' };

  // Org is required, branch everything under this
  if (matchedRoute?.match.params?.orgIdentifier) {
    context.orgId = matchedRoute.match.params.orgIdentifier;

    // Preference siteIdentifier over cloudId
    if (matchedRoute.match.params.siteIdentifier || urlSearch.cloudId) {
      context.cloudId = matchedRoute.match.params.siteIdentifier || urlSearch.cloudId;
    }
  }

  return loadQuery<BootstrapQueryType>(RelayEnvironment, BootstrapQuery, context.orgId ? { context } : {});
};
